import React, { useState } from "react";
import { PublicLayout, PageContainer, PageHeader } from "@/components/PublicLayout";
import { SeoContent } from "@/components/SeoContent";
import { DREAM_NUMBERS } from "@/data/dreamNumbers";
import { useSeo } from "@/lib/useSeo";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function DreamNumber() {
  useSeo({
    title: "Guwahati Morning Teer Dream Number Chart | Teer Dream Numbers List",
    description: "Complete Guwahati Morning Teer Dream Number chart - search your dream to find Direct, House and Ending reference numbers. Informational and entertainment only.",
    path: "/dream-number",
  });
  const [search, setSearch] = useState("");
  const rows = DREAM_NUMBERS.filter((d) => !search || d.dream.toLowerCase().includes(search.toLowerCase()));

  return (
    <PublicLayout>
      <PageContainer className="py-10">
        <PageHeader
          eyebrow="Reference Chart"
          title="Dream Number"
          subtitle="Traditional dream-to-number chart. Search your dream to see the Direct, House and Ending reference numbers. Informational & entertainment only."
        />

        <div className="relative mb-6 max-w-md">
          <MagnifyingGlass className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search your dream… (e.g. snake, water, money)"
            data-testid="dream-search"
            className="w-full h-12 pl-11 pr-4 rounded-xl border border-slate-200 bg-white text-slate-800 focus:outline-none focus:ring-2 focus:ring-brand/40"
          />
        </div>

        <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-[0_6px_24px_-6px_rgba(76,29,149,0.15)]" data-testid="dream-table">
          <div className="overflow-x-auto">
            <table className="w-full min-w-[560px]">
              <thead>
                <tr className="bg-gradient-to-r from-brand-900 to-brand text-white text-left">
                  <th className="py-3 px-3 font-heading text-xs font-bold uppercase tracking-wider w-14">Sl.</th>
                  <th className="py-3 px-3 font-heading text-xs font-bold uppercase tracking-wider">Dream</th>
                  <th className="py-3 px-3 font-heading text-xs font-bold uppercase tracking-wider">Direct</th>
                  <th className="py-3 px-3 font-heading text-xs font-bold uppercase tracking-wider text-center w-16">House</th>
                  <th className="py-3 px-3 font-heading text-xs font-bold uppercase tracking-wider text-center w-16">End</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((d, i) => (
                  <tr key={d.no} className={i % 2 === 0 ? "bg-white" : "bg-slate-50"} data-testid={`dream-row-${d.no}`}>
                    <td className="py-3 px-3 text-slate-400 font-semibold text-sm">{d.no}</td>
                    <td className="py-3 px-3 text-slate-800 font-medium text-sm">{d.dream}</td>
                    <td className="py-3 px-3 text-brand font-bold text-sm tabular-nums">{d.direct || "—"}</td>
                    <td className="py-3 px-3 text-center text-slate-800 font-bold tabular-nums">{d.house || "—"}</td>
                    <td className="py-3 px-3 text-center text-slate-800 font-bold tabular-nums">{d.ending || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-6 rounded-2xl bg-slate-50 border border-slate-100 p-5">
          <p className="text-sm text-slate-500 leading-relaxed">
            <strong className="text-slate-700">Disclaimer:</strong> This dream chart is folklore shared
            for entertainment and cultural reference only. Guwahati Morning Teer does not predict,
            guarantee or recommend any outcome.
          </p>
        </div>

        <SeoContent page="dream" />
      </PageContainer>
    </PublicLayout>
  );
}
